export default {
  closeIcon: 'closeIcon',
  offer: 'offer',
  close: 'close',
  cta: 'cta',
  title: 'title',
  body: 'body',
};
